import React, { useContext } from "react";
import { HomepageContext } from "../../../pages";
import CarouselNav from "../../navigation/CarouselNav.component";

export const Carousel = () => {
  const { nav } = useContext(HomepageContext);

  return <CarouselNav nav={nav} />;
};
